import React, { useEffect, useState } from "react";
import { Typography, Grid } from "@mui/material";
import { Stack } from "@mui/system";
import Dropdown from "../common/Dropdown";
import RoundToggle from "../common/RoundToggle";
import "./CreateFeedback.scss";
import InputField from "../common/InputField";
import Rating from "@mui/material/Rating";
import ButtonModule from "../common/Button";
import Delete from "../../Images/delete_red_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { StudioList } from "../../redux/TrainingCenter";
import {
  AdminAddFeedback,
  getFeedbackById,
  updateFeedback,
  revertAll,
} from "../../redux/feature/feedback";
import { toast } from "react-toastify";
import { components } from "react-select";
import CONSTANTS from "../../globals/common_utilities/constant";
import { useLocation, useNavigate } from "react-router-dom";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { FORM_VALIDATION, APP_ROUTES } from "../../globals/constants";
import { isEditable } from "@testing-library/user-event/dist/utils";

function CreateFeedback() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [trainingCenter, setTrainingCenter] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [traininngCenterList, setTrainingCenterList] = useState([]);
  const [checked, setChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(false);

  const [questions, setQuestion] = useState([
    {
      question: "How do you rate the training?",
      question_type: "star",
      options: "",
      question_sequence: "1",
    },
    {
      question: "How do you rate the instructor?",
      question_type: "star",
      options: "",
      question_sequence: "2",
    },
    {
      question: "How do you rate the virtual machine experience?",
      question_type: "star",
      options: "",
      question_sequence: "3",
    },
    {
      question: "",
      question_type: {
        label: "Textbox",
        id: "Textbox",
        value: "textbox",
      },
      options: "",
      answer: "",
      question_sequence: "4",
    },
  ]);
  const [multipleChoice, setMultipleChoice] = useState([
    {
      label: "Textbox",
      id: "Textbox",
      value: "textbox",
    },
    {
      label: "Radio",
      id: "Radio",
      value: "radio",
    },
    {
      label: "Checkbox",
      id: "Checkbox",
      value: "checkbox",
    },
  ]);
  const [feedbackId, setFeedbackId] = useState("");
  const cookies = new Cookies();
  const loginResponse = cookies.get("loginData");
  const studioListing = useSelector((state) => {
    return state.studio_list;
  });
  const AddTemplateResponse = useSelector((state) => {
    return state.admin_add_feedback;
  });
  const feedbackDetails = useSelector((state) => {
    console.log("check state-----", state);
    return state?.feedbackData_by_id;
  });
  useEffect(() => {
    getFeedbackDataById();
  }, [feedbackDetails?.getFeedbackById]);
  // useEffect(() => {
  //   AddTemplate();
  // }, [AddTemplateResponse?.add_feedback]);
  useEffect(() => {
    getStudioList();
  }, [studioListing?.StudioResponse]);
  const { email_id, token, role_code, name, studio_id, id } = loginResponse;

  const handleChange = (selected) => {
    setTrainingCenter(selected);
  };
  const getFeedbackDataById = () => {
    if (feedbackDetails.loading === true) {
      setIsLoading(true);
    } else {
      let data = feedbackDetails?.getFeedbackById?.data?.data;
      let questionData = [];
      let temp = data?.feedback_template_questions.map((value, index) => {
        if (
          value.question_type === "checkbox" ||
          value.question_type === "radio"
        ) {
          // if (value.options.length > 0) {
          //   value.options = JSON.parse(value.options);
          // }
          let questionType = multipleChoice.filter(
            (item) => item.value === value.question_type
          );
          let data = {
            question: value.question,
            feedback_template_id: value.feedback_template_id,
            question_sequence: value.question_sequence,
            options: JSON.parse(value.options),
            question_type: questionType.length > 0 ? questionType[0] : "star",
            is_active: value.is_active,
          };
          questionData[value.question_sequence - 1] = data;
          return value;
        }
        let questionType = multipleChoice.filter(
          (item) => item.value === value.question_type
        );
        let data = {
          question: value.question,
          feedback_template_id: value.feedback_template_id,
          question_sequence: value.question_sequence,
          options: value.options,
          question_type: questionType.length > 0 ? questionType[0] : "star",
          is_active: value.is_active,
        };
        questionData[value.question_sequence - 1] = data;
        return value;
      });

      let temp2 = data?.studio_templates.map((val) => ({
        id: val.studio_id,
        label: val.studio?.studio_name,
        value: val.studio_id,
      }));
      if (state?.action === "view") {
        setFeedbackId(data?.feedback_form_id);
        setTemplateName(data?.feedback_form_name);
        setQuestion(questionData ? [...questionData] : []);
        setChecked(data?.is_template_public);
        setTrainingCenter(temp2 ? [...temp2] : []);
        setEditable(true);
      } else if (state?.action === "copy") {
        setQuestion(questionData ? [...questionData] : []);
        setChecked(data?.is_template_public);
        setTrainingCenter(temp2 ? [...temp2] : []);
      }
    }
  };
  const getStudioList = async () => {
    if (studioListing?.loading === true) {
    } else {
      let data = studioListing?.StudioResponse.data?.rows;
      let data_studio = data?.map((item) => {
        let temp = {
          id: item.id,
          value: item.studio_name,
          label: `${item.studio_name}`,
        };
        return temp;
      });
      setTrainingCenterList([...data_studio]);
    }
  };
  const handleToggle = () => {
    setChecked(!checked);
  };
  const handleAddQuestion = () => {
    let data = [...questions];
    data.push({
      question: "",
      question_type: {
        label: "Textbox",
        id: "Textbox",
        value: "textbox",
      },
      options: [],
      question_sequence: data.length + 1,
    });
    setQuestion([...data]);
  };
  // const AddTemplate = () => {
  //   if (AddTemplateResponse.loding === true) {
  //   } else {
  //     if (AddTemplateResponse.add_feedback.status === 200) {
  //       toast.info(`Data Saved successfully`, {
  //         position: "bottom-right",
  //         autoClose: 3000,
  //         hideProgressBar: true,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //       navigate("/feedbacktemplate");
  //       dispatch(AdminAddFeedback.rejected());
  //     }
  //   }
  // };
  const handleMultipleChoice = (selected, index) => {
    let data = [...questions];
    if (selected.value === "textbox") {
      data[index].question_type = selected;
      setQuestion([...data]);
    } else {
      if (data[index].question_type.value === selected.value) {
        data[index].question_type = selected;
        data[index].options = [...data[index].options, ""];
      } else {
        data[index].question_type = selected;
        data[index].options = [""];
      }
      setQuestion([...data]);
    }
  };
  const handleQuestion = (value, index) => {
    let data = [...questions];
    data[index].question = value.target.value;
    setQuestion([...data]);
  };
  const handleAddOption = (value, index) => {
    let data = [...questions];
    if (data[index].options.length >= 0) {
      data[index].options.push("");
      setQuestion([...data]);
    } else {
      data[index].options.push("");
      setQuestion([...data]);
    }
  };

  const onOptionChange = (e, i, index) => {
    let data = [...questions];
    data[index].options[i] = e.target.value;
    setQuestion([...data]);
  };
  const handleOptionsDelete = (i, index) => {
    let data = [...questions];
    data[index].options.splice(i, 1);
    setQuestion([...data]);
  };

  const handleQuestionDelete = (index) => {
    let data = [...questions];
    data.splice(index, 1);
    setQuestion([...data]);
  };
  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };
  const isValid = () => {
    let error = false;
    let data = [...questions];
    if (templateName === "") {
      toast.error(`Please add template name`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
      return (error = true);
    } else {
      if (!FORM_VALIDATION.SCRIPT.test(templateName)) {
        toast.error(`Please add correct template name`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } 
      else if (templateName.trim().length === 0) {
        toast.error(`Please add correct template name`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      }
      else {
      }
    }
    if (checked === true) {
      if (trainingCenter.length === 0) {
        toast.error(`Please select the training center from the list`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      }
    }
    data.forEach((item, index) => {
      console.log("gggggfffbbv", item);
      if (item.question === "") {
        toast.error(`Please fill the question field`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (item.question) {
        if (!FORM_VALIDATION.SCRIPT.test(item.question)) {
          toast.error(`Please add correct question`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          return (error = true);
        } 
        else if (item.question.trim().length === 0) {
          toast.error(`Please add correct question`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          return (error = true);
        }
        else {
          console.log("ghghfhfhh", item.options);
          if (
            item.question_type.value === "radio" ||
            item.question_type.value === "checkbox"
          ) {
            if (item.options.length < 0) {
              toast.error(`Please add the options`, {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: { background: "#000", color: "#ffffff" },
              });
              return (error = true);
            } else {
              item.options.forEach((val, index) => {
                if (val === "") {
                  console.log("chk option val", val);
                  toast.error(`Please fill the options`, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    style: { background: "#000", color: "#ffffff" },
                  });
                  return (error = true);
                } else {
                  return error;
                }
              });
            }
          } else if (
            item.question_type.value === "textbox" ||
            item.question_type === "star"
          ) {
            return error;
          }
        }
        return error;
      }
    });

    return error;
  };
  const submit = async () => {
    let trainingData = trainingCenter.map((value) => {
      let id = value.id;
      return id;
    });
    if (!isValid()) {
      let temp = [];
      let data = [...questions];
      data.map((item, index) => {
        if (index < 3) {
          temp.push(item);
        } else {
          let type = item.question_type.value;
          let questions =
            item.question_type.value === "textbox"
              ? {
                  question: item.question,
                  question_type: type,
                  options: "",
                  question_sequence: item.question_sequence,
                }
              : {
                  question: item.question,
                  question_type: type,
                  options: JSON.stringify(item.options),
                  question_sequence: item.question_sequence,
                };
          temp.push(questions);
        }
      });
      console.log("check temp -----", temp);

      if (state?.action === "view") {
        let endPoints =
          role_code === "SUPER_ADMIN"
            ? "/feedback-template/update"
            : role_code === "STUDIO_ADMIN"
            ? "/studio/feedback-template/update"
            : "/instructor/feedback-template/update";
        let params = {
          feedback_template_id: state?.feedback_template_id,
        };
        let bodyParam = {
          feedback_form_id: feedbackId,
          feedback_form_name: templateName,
          is_template_public: checked,
          is_template_private: checked,
          created_by: role_code === "STUDIO_ADMIN" ? studio_id : id,
          studio_id: [...trainingData],
          questions: [...temp],
          updated_by: role_code === "STUDIO_ADMIN" ? studio_id : id,
        };
        const response = await api_call(
          "post",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + endPoints
          }`,
          params,
          {},
          bodyParam
        );
        if (response.status === 200) {
          toast.success(`Data Saved successfully`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          navigate("/feedbacktemplate");
        }
      } else {
        let bodyParam = {
          feedback_form_id: feedbackId,
          feedback_form_name: templateName,
          is_template_public: checked,
          is_template_private: checked,
          created_by: role_code === "STUDIO_ADMIN" ? studio_id : id,
          studio_id: [...trainingData],
          questions: [...temp],
        };
        let endPoints =
          role_code === "SUPER_ADMIN"
            ? "/feedback-template/add"
            : role_code === "STUDIO_ADMIN"
            ? "/studio/feedback-template/add"
            : "/instructor/feedback-template/add";
        const response = await api_call(
          "post",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + endPoints
          }`,
          {},
          {},
          bodyParam
        );
        console.log("response---", response.status, response);
        if (response.status === 200) {
          toast.success(`Data Saved successfully`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
          navigate("/feedbacktemplate");
        }
      }
    }
  };
  const renderOptions = (value, index) => {
    console.log("texxtbhchchjcjzgcjgcj", value, index);
    if (value.question_type?.value === "textbox") {
      return (
        <>
          <Grid conatiner>
            <input
              className="textbox_input"
              type="text"
              placeholder="Enter Answer"
              id="optionNameTest"
              maxlength={100}
              disabled={true}
            />
          </Grid>
        </>
      );
    } else if (
      value.question_type?.value === "checkbox" ||
      value.question_type?.value === "radio"
    ) {
      return (
        <>
          {value.options.map((item, i) => {
            return (
              <>
                <Stack className="set_option">
                  <Grid container>
                    <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                      {value.question_type?.value === "checkbox" ? (
                        <input
                          type="checkbox"
                          value="Private"
                          name="optradio"
                        />
                      ) : (
                        <input type="radio" value="Private" name="optradio" />
                      )}
                      <label className="containers font-style-10">
                        <input
                          className="radio_input"
                          type="text"
                          placeholder="Options"
                          id="optionNameTest"
                          maxlength={100}
                          value={item}
                          onChange={(e) => onOptionChange(e, i, index)}
                        />
                        <span class="checkmark"></span>
                      </label>
                    </Grid>
                    {value.options.length > 1 ? (
                      <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                        <Typography
                          variant="h6"
                          onClick={() =>
                            editable === true
                              ? ""
                              : handleOptionsDelete(i, index)
                          }
                        >
                          x
                        </Typography>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                </Stack>
              </>
            );
          })}
        </>
      );
    }
  };
  useEffect(() => {
    let randomId = Math.floor(
      Math.pow(10, 10 - 1) + Math.random() * 9 * Math.pow(10, 10 - 1)
    );
    setFeedbackId(randomId);
  }, []);
  useEffect(() => {
    if (role_code === "SUPER_ADMIN") {
      dispatch(StudioList({ token }));
    }
    if (state?.action === "view" || state?.action === "copy") {
      let endPoints =
        role_code === "SUPER_ADMIN"
          ? "/feedbackTemplateById"
          : role_code === "STUDIO_ADMIN"
          ? "/studio/feedbackTemplateById"
          : "/instructor/feedbackTemplateById";
      let params =
        role_code === "SUPER_ADMIN"
          ? {
              unique_id: id,
              feedback_template_id: state?.feedback_template_id,
            }
          : role_code === "STUDIO_ADMIN"
          ? {
              feedback_template_id: state?.feedback_template_id,
            }
          : {
              unique_id: id,
              feedback_template_id: state?.feedback_template_id,
            };
      dispatch(getFeedbackById({ params, endPoints }));
    }
  }, []);
  const gotolistingPage = (training) => {
    navigate(APP_ROUTES.FEEDBACK_TEMPLATE_LISTING, {
      state: {},
    });
  };
  return (
    <>
      <Stack className="create_feedback">
        <Stack className="feedback_title">
          <Grid container>
            <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
              <Stack direction="row" marginTop="2%">
                <Typography
                  onClick={gotolistingPage}
                  className="larger_f_bold feedback"
                >
                  Feedback &#62;&#62;
                </Typography>
                <Typography className="larger_f_bold">
                  {state?.action === "view"
                    ? !editable
                      ? "Edit Feedback Template"
                      : "View Feedback Template"
                    : "Create Feedback Template"}
                </Typography>
              </Stack>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
							<Typography className="image_heading">
								Create Feedback Form
							</Typography>
						</Grid> */}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              {state?.action === "view" ? (
                editable === true ? (
                  <ButtonModule
                    className="edit_btn"
                    role="primary"
                    value={"Edit"}
                    onClick={() => setEditable(false)}
                  />
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Stack>
        <Stack className="set_feedback">
          <Grid container rowspacing={4}>
            {role_code === "SUPER_ADMIN" ? (
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                <Typography className="training_type">Feedback Type</Typography>
              </Grid>
            ) : (
              ""
            )}
            {role_code === "SUPER_ADMIN" ? (
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <Grid container>
                  <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                    <Typography className="set_toggle_header">
                      Private
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2} xl={1}>
                    <RoundToggle
                      checked={checked}
                      onChange={handleToggle}
                      className="set_toggle_header"
                      disabled={editable === true ? true : false}
                    />
                  </Grid>
                  <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                    <Typography className="set_toggle_header_public">
                      Public
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            {role_code === "SUPER_ADMIN" && checked === true ? (
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <Dropdown
                  placeholder="Select Training Center"
                  options={traininngCenterList}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={trainingCenter}
                  isDisabled={editable === true ? true : false}
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          <Stack className="template_details">
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className="template_name">
                  Enter Template Name
                </Typography>
                <InputField
                  placeholder="Enter Template Name"
                  className="set_templateHeader"
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                  disabled={editable === true ? true : false}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Typography className="feedback_id ">
                  Feedback ID - {feedbackId}
                </Typography>
              </Grid>
            </Grid>
          </Stack>
          <Stack>
            {questions.map((item, index) => {
              if (index < 3) {
                return (
                  <Stack className="template_details">
                    <Grid container>
                      <Stack direction="column">
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Typography className="questions">
                            {item.question}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <Rating
                            name="size-small"
                            // precision={0.5}
                            disabled={true}
                            max={5}
                          />
                        </Grid>
                      </Stack>
                    </Grid>
                  </Stack>
                );
              } else {
                return (
                  <Stack className="template_details">
                    <Grid container>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <InputField
                          placeholder="Enter question "
                          value={item.question}
                          onChange={(value) => handleQuestion(value, index)}
                          disabled={editable === true ? true : false}
                        />
                        {renderOptions(item, index)}
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}></Grid>
                      <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                        <Dropdown
                          placeholder="Multiple Choices"
                          options={multipleChoice}
                          onChange={(selected) =>
                            handleMultipleChoice(selected, index)
                          }
                          defaultValue={multipleChoice[0]}
                          value={item.question_type}
                          isDisabled={editable === true ? true : false}
                        />
                      </Grid>
                      {item.question_type.value === "textbox" ? (
                        ""
                      ) : (
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <ButtonModule
                            className="set_addOption"
                            value="Add Option"
                            role="primary"
                            onClick={() =>
                              editable === true
                                ? ""
                                : handleAddOption("option", index)
                            }
                            disabled={editable === true ? true : false}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Stack className="set_delete">
                          <img
                            src={Delete}
                            onClick={() =>
                              editable === true
                                ? ""
                                : handleQuestionDelete(index)
                            }
                            disabled={editable === true ? true : false}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                );
              }
            })}
          </Stack>
          <Stack>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                className="set_addQuestion"
                onClick={() => (editable === true ? "" : handleAddQuestion())}
                // disabled={editable === true ? true : false}
              >
                +
              </Typography>
            </Grid>
          </Stack>
          <Stack direction="row">
            <ButtonModule
              role="default"
              value="Back"
              onClick={() => navigate("/feedbacktemplate")}
            />
            <ButtonModule
              role="primary"
              value={state?.action === "view" ? "Update" : "Save"}
              disabled={editable === true ? true : false}
              onClick={() => submit()}
              // onClick={() => isValid()}
            />
          </Stack>
        </Stack>
      </Stack>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default CreateFeedback;
